<template>
	<div class="claim-detail-container">
		<div class="claim-detail" v-loading="loading">
			<el-card class="box-card" shadow="never">
				<div slot="header" class="clearfix">
					<span class="card-title">理赔基本信息</span>
				</div>

				<el-descriptions :column="2" border>
					<el-descriptions-item label="理赔ID">{{ info.id || '-' }}</el-descriptions-item>
					<el-descriptions-item label="保单号">{{ info.policy_no || '-' }}</el-descriptions-item>
					<el-descriptions-item label="报案号">{{ info.register_no || '-' }}</el-descriptions-item>
					<el-descriptions-item label="赔案号">{{ info.claim_no || '-' }}</el-descriptions-item>
					<el-descriptions-item label="赔款序号">{{ info.sequence || '-' }}</el-descriptions-item>
					<el-descriptions-item label="案件状态">
						<el-tag
							:type="getCaseStatusTagType(info.case_status)">{{ getCaseStatusText(info.case_status) }}</el-tag>
					</el-descriptions-item>
					<el-descriptions-item label="理赔状态">
						<el-tag :type="getStatusTagType(info.status)">{{ getStatusText(info.status) }}</el-tag>
					</el-descriptions-item>
					<el-descriptions-item label="赔付状态">
						<el-tag :type="info.settle_status ? 'success' : 'warning'">
							{{ info.settle_status ? '已赔付' : '未赔付' }}
						</el-tag>
					</el-descriptions-item>
					<el-descriptions-item label="赔付金额">¥{{ info.claim_amount || '0.00' }}</el-descriptions-item>
					<el-descriptions-item label="报案时间">{{ info.regist_time || '-' }}</el-descriptions-item>
					<el-descriptions-item label="赔付时间">{{ info.claim_time || '-' }}</el-descriptions-item>
					<el-descriptions-item label="创建时间">{{ info.created_at || '-' }}</el-descriptions-item>
					<el-descriptions-item label="更新时间">{{ info.updated_at || '-' }}</el-descriptions-item>
				</el-descriptions>
			</el-card>

			<el-card class="box-card" shadow="never" style="margin-top: 20px;">
				<div slot="header" class="clearfix">
					<span class="card-title">保险产品信息</span>
				</div>

				<el-descriptions :column="2" border>
					<el-descriptions-item label="保险产品">{{ info.goods_name || '-' }}</el-descriptions-item>
					<el-descriptions-item label="产品规格">{{ info.goods_specs_name || '-' }}</el-descriptions-item>
					<el-descriptions-item label="承保公司">{{ info.insurer_name || '-' }}</el-descriptions-item>
				</el-descriptions>
			</el-card>

			<el-card class="box-card" shadow="never" style="margin-top: 20px;">
				<div slot="header" class="clearfix">
					<span class="card-title">报案信息</span>
				</div>

				<el-descriptions :column="2" border>
					<el-descriptions-item label="报案人">{{ info.reporter || '-' }}</el-descriptions-item>
					<el-descriptions-item label="报案人电话">{{ info.reporter_telephone || '-' }}</el-descriptions-item>
					<el-descriptions-item label="报案地点">{{ info.regist_address || '-' }}</el-descriptions-item>
					<el-descriptions-item label="报案时间">{{ info.regist_time || '-' }}</el-descriptions-item>
				</el-descriptions>
			</el-card>

			<el-card class="box-card" shadow="never" style="margin-top: 20px;">
				<div slot="header" class="clearfix">
					<span class="card-title">被保险人信息</span>
				</div>

				<el-descriptions :column="2" border>
					<el-descriptions-item label="被保险人姓名">{{ info.insurant_name || '-' }}</el-descriptions-item>
					<el-descriptions-item label="证件类型">{{ getCertTypeText(info.insurant_cert_type) }}</el-descriptions-item>
					<el-descriptions-item label="证件号码">{{ info.insurant_cert_no || '-' }}</el-descriptions-item>
				</el-descriptions>
			</el-card>

			<el-card class="box-card" shadow="never" style="margin-top: 20px;">
				<div slot="header" class="clearfix">
					<span class="card-title">出险经过</span>
				</div>

				<div class="accident-desc">
					{{ info.accident_desc || '无' }}
				</div>
			</el-card>

			<el-card class="box-card" shadow="never" style="margin-top: 20px;">
				<div slot="header" class="clearfix">
					<span class="card-title">银行账户信息</span>
				</div>

				<el-descriptions :column="2" border>
					<el-descriptions-item label="账户名">{{ info.account_name || '-' }}</el-descriptions-item>
					<el-descriptions-item label="账户号">{{ info.account_code || '-' }}</el-descriptions-item>
					<el-descriptions-item label="开户行">{{ info.bank_name_cn || '-' }}</el-descriptions-item>
					<el-descriptions-item label="银行名称">{{ info.formal_bank_bame_cn || '-' }}</el-descriptions-item>
					<el-descriptions-item label="开户省份">{{ info.deposit_bank_province || '-' }}</el-descriptions-item>
					<el-descriptions-item label="开户城市">{{ info.deposit_bank_city || '-' }}</el-descriptions-item>
				</el-descriptions>
			</el-card>

			<!-- 理赔文件展示 -->
			<el-card class="box-card" shadow="never" style="margin-top: 20px;">
				<div slot="header" class="clearfix">
					<span class="card-title">理赔文件</span>
				</div>

				<el-tabs v-model="activeFileTab">
					<el-tab-pane label="门诊病历" name="outpatient">
						<div class="file-section">
							<div class="file-list" v-if="info.outpatient_record_file">
								<page-images v-model="info.outpatient_record_file" disabled />
							</div>
							<div v-else class="no-files">暂无门诊病历文件</div>
						</div>
					</el-tab-pane>

					<el-tab-pane label="医疗发票" name="medical">
						<div class="file-section">
							<div class="file-list" v-if="info.medical_invoice_file">
								<page-images v-model="info.medical_invoice_file" disabled />
							</div>
							<div v-else class="no-files">暂无医疗发票文件</div>
						</div>
					</el-tab-pane>

					<el-tab-pane label="费用明细" name="cost">
						<div class="file-section">
							<div class="file-list" v-if="info.cost_detail_file">
								<page-images v-model="info.cost_detail_file" disabled />
							</div>
							<div v-else class="no-files">暂无费用明细文件</div>
						</div>
					</el-tab-pane>

					<el-tab-pane label="检查报告" name="check">
						<div class="file-section">
							<div class="file-list" v-if="info.check_report_file">
								<page-images v-model="info.check_report_file" disabled />
							</div>
							<div v-else class="no-files">暂无检查报告文件</div>
						</div>
					</el-tab-pane>
				</el-tabs>
			</el-card>

			<el-card class="box-card" shadow="never" style="margin-top: 20px;">
				<div slot="header" class="clearfix">
					<span class="card-title">退票信息</span>
				</div>

				<el-descriptions :column="1" border>
					<el-descriptions-item label="退票原因" :labelStyle="{width: '120px'}">
						<div class="return-reason">{{ info.return_reason || '无' }}</div>
					</el-descriptions-item>
				</el-descriptions>
			</el-card>

			<!-- 审核操作区域 - 固定在组件底部 -->
			<div class="fixed-actions" v-if="info.case_status === '00' && info.status == 0">
				<div class="action-content">
					<el-button type="primary" size="medium" @click="handleAudit('pass')" :loading="auditLoading">
						审核通过
					</el-button>
					<el-button type="danger" size="medium" @click="showRejectDialog" :loading="auditLoading">
						审核不通过
					</el-button>
				</div>
			</div>

			<!-- 审核不通过弹窗 -->
			<el-dialog
				title="审核不通过"
				:visible.sync="rejectDialogVisible"
				width="45%"
				:modal="false"
				:close-on-click-modal="false"
				:close-on-press-escape="false"
			>
				<el-form :model="rejectForm" :rules="rejectRules" ref="rejectFormRef" label-width="100px">
					<el-form-item label="退票原因" prop="return_reason">
						<el-input
							type="textarea"
							:rows="10"
							v-model="rejectForm.return_reason"
							placeholder="请输入退票原因"
							maxlength="500"
							show-word-limit
						></el-input>
					</el-form-item>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button @click="rejectDialogVisible = false">取消</el-button>
					<el-button type="danger" @click="handleAudit('reject')" :loading="auditLoading">确定</el-button>
				</div>
			</el-dialog>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'ClaimDetail',
		props: {
			id: {
				type: [String, Number],
				required: true
			}
		},
		data() {
			return {
				loading: false,
				auditLoading: false,
				info: {},
				activeFileTab: 'outpatient',
				rejectDialogVisible: false,
				rejectForm: {
					return_reason: ''
				},
				rejectRules: {
					return_reason: [
						{ required: true, message: '请输入退票原因', trigger: 'blur' },
						{ min: 5, message: '退票原因至少5个字符', trigger: 'blur' }
					]
				}
			}
		},
		computed: {
			// 门诊病历文件
			outpatientFiles() {
				return this.info.outpatient_record_file;
			},

			// 医疗发票文件
			medicalFiles() {
				return this.info.medical_invoice_file;
			},

			// 费用明细文件
			costFiles() {
				return this.info.cost_detail_file;
			},

			// 检查报告文件
			checkFiles() {
				return this.info.check_report_file;
			}
		},
		mounted() {
			this.loadClaimDetail();
		},
		methods: {
			// 处理文件字段
			processFileField(field) {
				if (!field) return [];

				if (Array.isArray(field)) {
					return field;
				} else if (typeof field === 'string') {
					try {
						const parsed = JSON.parse(field);
						if (Array.isArray(parsed)) {
							return parsed;
						}
					} catch (e) {
						// 如果不是 JSON，按逗号分割
						return field.split(',').map(file => file.trim()).filter(file => file);
					}
				}

				return [];
			},

			// 加载理赔详情
			async loadClaimDetail() {
				this.loading = true;
				try {
					const res = await this.$get('app-order-claim/' + this.id);
					this.info = res.data || {};
				} catch (error) {
					this.$notify.error({
						title: '错误',
						message: error || '加载理赔信息失败'
					});
				} finally {
					this.loading = false;
				}
			},

			// 显示审核不通过弹窗
			showRejectDialog() {
				this.rejectForm.return_reason = '';
				this.rejectDialogVisible = true;
				this.$nextTick(() => {
					this.$refs.rejectFormRef && this.$refs.rejectFormRef.clearValidate();
				});
			},

			// 审核操作
			async handleAudit(action) {
				let confirmMessage = '';
				let requestData = {};

				if (action === 'pass') {
					confirmMessage = '确定要通过此理赔申请吗？通过后将提交至保险公司审核。';
					requestData = {
						case_status: '01', // 审核通过，状态变为立案录入
						status: 0 // 理赔状态保持进行中
					};
				} else {
					// 审核不通过需要验证表单
					if (!this.rejectForm.return_reason) {
						this.$message.warning('请输入退票原因');
						return;
					}
					
					if (this.rejectForm.return_reason.length < 5) {
						this.$message.warning('退票原因至少5个字符');
						return;
					}

					confirmMessage = '确定要拒绝此理赔申请吗？';
					requestData = {
						status: 2, // 理赔状态变为未通过
						return_reason: this.rejectForm.return_reason // 退票原因
					};
				}

				try {
					await this.$confirm(confirmMessage, '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					});

					this.auditLoading = true;
					
					await this.$put('app-order-claim/' + this.id, requestData);
					
					this.$message.success(action === 'pass' ? '审核通过成功' : '审核拒绝成功');
					
					// 关闭弹窗
					if (action === 'reject') {
						this.rejectDialogVisible = false;
					}
					
					// 重新加载数据
					await this.loadClaimDetail();
					
					// 通知父组件更新列表
					this.$emit('audit-success');
					
				} catch (error) {
					if (error !== 'cancel') {
						this.$message.error('操作失败：' + (error || '网络错误'));
					}
				} finally {
					this.auditLoading = false;
				}
			},

			// 获取证件类型文本
			getCertTypeText(type) {
				const typeMap = {
					'01': '身份证',
					'02': '护照',
					'03': '港澳居民往来内地通行证',
					'04': '台湾居民往来大陆通行证'
				};
				return typeMap[type] || '未知';
			},

			// 获取案件状态文本
			getCaseStatusText(status) {
				const statusMap = {
					'00': '未提交',
					'01': '立案录入',
					'02': '立案审核',
					'03': '定损',
					'04': '核损',
					'05': '核损初审',
					'06': '核损复审',
					'07': '单证确认',
					'08': '结案理算',
					'09': '结案核赔',
					'11': '已决已结',
					'12': '零赔付',
					'13': '拒赔',
					'14': '立案注销',
					'15': '报案注销',
					'25': '已决未结',
					'26': '已决已结',
					'27': '结案核赔',
					'28': '结案理算',
					'19': '结案理算',
					'20': '结案核赔',
					'10': '已决未结',
					'16': '零结案',
					'17': '拒赔',
					'18': '立案注销',
					'29': '核价'
				};
				return statusMap[status] || '未知';
			},

			// 获取案件状态标签类型
			getCaseStatusTagType(status) {
				if (['00'].includes(status)) return 'info';
				if (['11', '12', '13', '14', '15', '26'].includes(status)) return 'success';
				if (['01', '02', '03', '04', '05', '06', '07'].includes(status)) return 'warning';
				if (['08', '09', '10', '16', '17', '18', '19', '20', '25', '27', '28', '29'].includes(status))
					return 'info';
				return 'info';
			},

			// 获取状态文本
			getStatusText(status) {
				const statusMap = {
					0: '进行中',
					1: '已完成',
					2: '未通过'
				};
				return statusMap[status] || '未知';
			},

			// 获取状态标签类型
			getStatusTagType(status) {
				const typeMap = {
					0: 'warning', // 进行中
					1: 'success', // 已完成
					2: 'danger' // 未通过
				};
				return typeMap[status] || 'info';
			}
		},
		watch: {
			id: {
				immediate: true,
				handler(newVal) {
					if (newVal) {
						this.loadClaimDetail();
					}
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	.claim-detail-container {
		display: flex;
		justify-content: center;
		width: 100%;
		padding: 20px 0;
	}

	.claim-detail {
		width: 60%;
		min-width: 800px;
		max-width: 1200px;
		position: relative;
		min-height: 100%;
		
		.box-card {
			margin-bottom: 0;

			.card-title {
				font-size: 16px;
				font-weight: bold;
				color: #303133;
			}
		}

		.accident-desc {
			padding: 15px;
			line-height: 1.6;
			white-space: pre-wrap;
			background-color: #f8f9fa;
			border-radius: 4px;
			min-height: 100px;
		}

		.return-reason {
			min-height: 20px;
			white-space: pre-wrap;
			word-break: break-all;
		}

		.file-section {
			padding: 16px;

			.file-list {
				::v-deep .el-upload-list--picture-card {
					display: flex;
					flex-wrap: wrap;
					gap: 10px;
				}

				::v-deep .el-upload-list__item {
					margin: 0;
				}
			}

			.no-files {
				text-align: center;
				color: #909399;
				padding: 40px;
				font-style: italic;
			}
		}

		/* 固定在组件底部的操作栏 - 简洁大气样式 */
		.fixed-actions {
			position: sticky;
			bottom: 0;
			background: #fff;
			border-top: 1px solid #e8e8e8;
			padding: 16px 0;
			margin: 30px 0 0 0;
			box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.06);
			z-index: 99;
			
			.action-content {
				display: flex;
				justify-content: center;
				align-items: center;
				gap: 16px;
				
				.el-button {
					min-width: 120px;
					height: 40px;
					font-size: 14px;
					border-radius: 4px;
					
					&.el-button--primary {
						background-color: #5B8CFF;
						border-color: #5B8CFF;
						
						&:hover {
							background-color: #4A7DFF;
							border-color: #4A7DFF;
						}
					}
				}
			}
		}
	}

	// 打印样式
	@media print {
		.claim-detail-container {
			padding: 0;
		}
		
		.claim-detail {
			width: 100%;
			min-width: auto;
			max-width: none;
			
			.box-card {
				box-shadow: none !important;
				border: 1px solid #ddd;
				margin-bottom: 15px;
			}

			.fixed-actions {
				display: none;
			}

			.el-card__header {
				background-color: #f5f7fa !important;
				border-bottom: 1px solid #ddd;
			}

			// 隐藏文件标签页内容
			.el-tabs__content {
				display: none;
			}
		}
	}
</style>